import React, {useEffect, useRef, useState} from "react";
import {Input, InputProps} from "@chakra-ui/react";

interface DebouncedInputProps extends Omit<InputProps, "value" | "onChange"> {
    value: string;
    onCommit: (value: string) => void;
    delay?: number;
}

/** Typing stays instant (local state); the expensive parent update fires only after the user pauses. */
export function DebouncedInput({value, onCommit, delay = 400, ...rest}: DebouncedInputProps) {
    const [local, setLocal] = useState(value);
    const timer = useRef<ReturnType<typeof setTimeout>>();

    useEffect(() => {
        setLocal(value);
    }, [value]);

    useEffect(() => () => clearTimeout(timer.current), []);

    return (
        <Input {...rest} value={local} onChange={e => {
            const next = e.target.value;
            setLocal(next);
            clearTimeout(timer.current);
            timer.current = setTimeout(() => onCommit(next), delay);
        }}/>
    );
}
